module.exports = __webpack_public_path__ + "img/qq9.c5c6ba08.jpg";